/**
 * canDragArTableRows
 *
 * The one gate on ArTable row dragging, so the flat path and the bundle path can
 * never disagree: `ArTableBody` derives `dndEnabled` from it and
 * `resolveArBundleDisplay` derives every bundle's `dropAvailability` from the
 * same call. `rowsWithheld` closes dragging because `moveRowInManualOrder`
 * bisects the LexoRank interval between the dragged row's two RENDERED
 * neighbours, and the rows a split or column filter withheld between them keep
 * their old ranks. Owns `ArTableRowDragState`, the gate's input, so the
 * resolver imports it from here and not the other way round.
 */

/**
 * The table's drag posture: `manualOrderMode` is `viewSort.mode === 'order'`,
 * `disabled` the table's effective read-only state, `rowsWithheld` "a split or
 * a column filter is narrowing this table".
 */
type ArTableRowDragState = {
  manualOrderMode: boolean;
  disabled: boolean;
  rowsWithheld: boolean;
};

function canDragArTableRows(drag: ArTableRowDragState): boolean {
  return drag.manualOrderMode && !drag.disabled && !drag.rowsWithheld;
}

export { canDragArTableRows };
export type { ArTableRowDragState };
